import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HomeIcon(props: IconProps) {
    return <Icon {...props} iconKey={"home"}/>
}
